import { ORDER_STATUS_SEQUENCE, type OrderStatus } from '@/types/orderStatus';

const ORDER_STATUS_SET: ReadonlySet<OrderStatus> = new Set<OrderStatus>(ORDER_STATUS_SEQUENCE);

export const coerceOrderStatus = (value: unknown): OrderStatus | null => {
  if (typeof value !== 'string') {
    return null;
  }
  const candidate = value.trim().toUpperCase() as OrderStatus;
  if (!candidate) {
    return null;
  }
  return ORDER_STATUS_SET.has(candidate) ? candidate : null;
};
